import { Building2, ArrowUpRight } from "lucide-react";

/** Dims the map when no environment is selected, pointing the user at the
 *  env/site switcher in the header (top-right). The switcher lives outside this
 *  overlay, so it stays clickable. Sits above MapLoadingOverlay (z-20). */
export function MapEnvOverlay() {
  return (
    <div className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 bg-background/70 px-6 text-center backdrop-blur-sm">
      <Building2 className="size-8 text-muted-foreground" />
      <div className="space-y-1">
        <p className="font-medium">No environment selected</p>
        <p className="inline-flex items-center gap-1 text-sm text-muted-foreground">
          Choose one from the switcher at the top&nbsp;right
          <ArrowUpRight className="size-4" />
        </p>
      </div>
    </div>
  );
}
